import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    searchedSerialNumber: "",
    selectedConfigType: "",
    productOptions: [],
    productComponents: [],
    loading: Boolean(false),
    error: null
};

export const getProductOptions = createAsyncThunk(
    "productConfig/getProductOptions",
    async (searchObject) => {
        const optionsApiUrl = "/product/product-config";
        try {
            const response = await wtyReportApi.get(optionsApiUrl, searchObject);
            if (response.status !== 200) {
                new Error("Error occurred while trying to fetch the option codes.")
            }
            return await response.data;
        } catch (error) {
        }
    }
);

export const getProductComponents = createAsyncThunk(
    "productConfig/getProductComponents",
    async (serialNumber) => {
        const optionsApiUrl = "/product/product-component";
        const params = {
            serialNumber: serialNumber
        }
        try {
            const response = await wtyReportApi.get(optionsApiUrl, params);
            if (response.status !== 200) {
                new Error("Error occurred while trying to fetch the option codes.")
            }
            return await response.data;
        } catch (error) {
        }
    }
);

const productConfigSlice = createSlice({
    name: "productConfig",
    initialState,
    reducers: {
        resetProductConfig: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(getProductOptions.pending, state => {
                state.loading = true;
                state.productOptions = [];
            })
            .addCase(getProductOptions.rejected, (state, action) => {
                state.loading = false;
                state.productOptions = [];
                state.error = action.payload;
            })
            .addCase(getProductOptions.fulfilled, (state, action) => {
                state.loading = false;
                state.productOptions = action.payload;
                state.error = null;
            })
            .addCase(getProductComponents.pending, state => {
                state.loading = true;
                state.productComponents = [];
            })
            .addCase(getProductComponents.rejected, (state, action) => {
                state.loading = false;
                state.productComponents = [];
                state.error = action.payload;
            })
            .addCase(getProductComponents.fulfilled, (state, action) => {
                state.loading = false;
                state.productComponents = action.payload;
                state.error = null;
            })
    }
});

export const {resetProductConfig} = productConfigSlice.actions;

export const productOptions = state => state.productConfig.productOptions;
export const productComponents = state => state.productConfig.productComponents;

export const productsLoading = state => state.productConfig.loading;
export default productConfigSlice.reducer